module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7t6Y8"))).then(() => parcelRequire('ikE14'));